export default "assets/images/icons/arrow-b1e33d7f.svg";